<template>
  <ImportList></ImportList>
</template>

<script>
export default {
  name: 'ImportListPage'
}
</script>

<style>

</style>